import { Logo } from "@/components/Logo";

const LINKS = [
  { label: "Servicios", href: "#servicios" },
  { label: "Sectores", href: "#sectores" },
  { label: "Diferenciadores", href: "#diferenciadores" },
  { label: "Contacto", href: "#contacto" },
];

const Footer = () => (
  <footer className="hairline-t bg-obsidian pb-10 pt-16" data-testid="footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div className="max-w-sm">
          <Logo />
          <p className="mt-5 font-body text-sm leading-relaxed text-slate-500">
            Soberanía tecnológica, infraestructura de misión crítica y cumplimiento
            gubernamental para el Occidente de México.
          </p>
        </div>
        <nav className="flex flex-col gap-3" aria-label="Pie de página">
          <span className="mb-1 font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-500">
            Navegación
          </span>
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`footer-link-${l.label.toLowerCase()}`}
              className="font-body text-sm text-slate-400 transition-colors hover:text-neon"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex flex-col gap-3">
          <span className="mb-1 font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-500">
            Cobertura
          </span>
          <span className="font-body text-sm text-slate-400">Zulia · Lara · Falcón · Táchira</span>
          <span className="font-body text-sm text-slate-400">contacto@tioccidente.com</span>
        </div>
      </div>
      <div className="hairline-t mt-14 flex flex-col gap-3 pt-7 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-body text-xs text-slate-600">
          © {new Date().getFullYear()} Tecnología e Innovación de Occidente, C.A. Todos los derechos reservados.
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
          Diseñado con precisión en el Occidente
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
